export class loginService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    login(username, password) {
        const action = "Login";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                user: username,
                password: password,
                action
            };
            this.SingletonWebSocket.send(message);
        }
    }
    closeSession() {
        const action = "Logout";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
            this.SingletonSharedData.setCurrentStatus("Logout");
        }
    }
    SetReady() {
        const action = "setReady";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    setReadyWithPassword(agentPwd,supervisorPwd) {
        const action = "setReadyWithPassword";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                agentPwd,
                supervisorPwd,
                action: action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    ChangePassword(aCurrentPassword, aNewPassword) {
        const action = "ChangePassword";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                aCurrentPassword: aCurrentPassword,
                aNewPassword: aNewPassword,
                action: "Settings",
                subaction: action
            };
            this.SingletonWebSocket.send(message);
        }
    }
    validateTelephony() {
        const action = "validateTelephony";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            };
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/loginService.js